import React from 'react';
import { Link } from 'react-router-dom';

function About() {
  const appVersion = '1.0.0';

  return (
    <div style={{ backgroundColor: '#F8FAFC', minHeight: '100vh' }}>
      {/* Header with gradient - Flutter style */}
      <div style={{
        background: 'linear-gradient(135deg, #FF6961 0%, #FF8A80 100%)',
        padding: '48px 16px',
        textAlign: 'center',
        marginBottom: '24px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
      }}>
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#FFFFFF',
          margin: '0 0 8px 0',
          letterSpacing: '-0.5px'
        }}>
          About Foodwinc
        </h1>
        <p style={{
          color: 'rgba(255, 255, 255, 0.9)',
          fontSize: '15px',
          margin: 0,
          fontWeight: '400'
        }}>
          Learn more about our platform
        </p>
      </div>

      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '0 16px 32px 16px' }}>
        {/* App Logo and Version Card */}
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '12px',
          padding: '32px 24px',
          textAlign: 'center',
          marginBottom: '16px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
        }}>
          <div style={{
            width: '96px',
            height: '96px',
            borderRadius: '48px',
            background: 'linear-gradient(135deg, #FF6961 0%, #FF8A80 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px auto',
            fontSize: '48px',
            boxShadow: '0 4px 12px rgba(255, 105, 97, 0.2)'
          }}>
            🍽️
          </div>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#0F172A',
            marginBottom: '8px',
            letterSpacing: '-0.5px'
          }}>
            Foodwinc Restaurant
          </h2>
          <div style={{
            display: 'inline-block',
            backgroundColor: '#F8FAFC',
            padding: '6px 16px',
            borderRadius: '8px',
            marginBottom: '16px'
          }}>
            <span style={{
              color: '#64748B',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              Version {appVersion}
            </span>
          </div>
          <p style={{
            color: '#64748B',
            fontSize: '15px',
            lineHeight: '1.6',
            margin: '0',
            maxWidth: '400px',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}>
            Foodwinc is a comprehensive food delivery platform that connects restaurants
            with hungry customers. We're committed to helping restaurants grow their
            business and reach more customers.
          </p>
        </div>

        {/* Menu Items */}
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '12px',
          overflow: 'hidden',
          marginBottom: '16px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
        }}>
          <a
            href="https://foodwinc.com/terms.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '16px 20px',
              textDecoration: 'none',
              color: '#0F172A',
              borderBottom: '1px solid #F1F5F9',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F8FAFC'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              backgroundColor: '#FFF1F0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px'
            }}>
              📜
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '2px' }}>
                Terms of Service
              </div>
              <div style={{ fontSize: '13px', color: '#64748B' }}>
                Read our terms and conditions
              </div>
            </div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#94A3B8' }}>
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>

          <a
            href="https://foodwinc.com/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '16px 20px',
              textDecoration: 'none',
              color: '#0F172A',
              borderBottom: '1px solid #F1F5F9',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F8FAFC'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              backgroundColor: '#FFF1F0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px'
            }}>
              🔒
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '2px' }}>
                Privacy Policy
              </div>
              <div style={{ fontSize: '13px', color: '#64748B' }}>
                How we handle your data
              </div>
            </div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#94A3B8' }}>
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>

          <Link
            to="/restaurant/help-support"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              padding: '16px 20px',
              textDecoration: 'none',
              color: '#0F172A',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F8FAFC'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '8px',
              backgroundColor: '#FFF1F0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px'
            }}>
              💬
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '2px' }}>
                Contact Support
              </div>
              <div style={{ fontSize: '13px', color: '#64748B' }}>
                Get help with any issues
              </div>
            </div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{ color: '#94A3B8' }}>
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>

        {/* Contact Information */}
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '12px',
          padding: '24px 20px',
          marginBottom: '16px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '700',
            marginBottom: '20px',
            color: '#0F172A',
            letterSpacing: '-0.3px'
          }}>
            Contact Us
          </h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{
              padding: '16px',
              backgroundColor: '#F8FAFC',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <div style={{ fontSize: '24px' }}>📧</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', color: '#64748B', marginBottom: '2px' }}>Email</div>
                <a href="mailto:foodwinc@gmail.com" style={{
                  color: '#FF6961',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  foodwinc@gmail.com
                </a>
              </div>
            </div>

            <div style={{
              padding: '16px',
              backgroundColor: '#F8FAFC',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <div style={{ fontSize: '24px' }}>🌐</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', color: '#64748B', marginBottom: '2px' }}>Website</div>
                <a href="https://foodwinc.com" target="_blank" rel="noopener noreferrer" style={{
                  color: '#FF6961',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  foodwinc.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div style={{
          textAlign: 'center',
          padding: '24px 16px',
          color: '#64748B'
        }}>
          <p style={{ margin: 0, fontSize: '14px' }}>
            © {new Date().getFullYear()} Foodwinc. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
